<fq-progress-bar [colorPalette]="progressBarColorPalette" [configuration]="progressBarConfiguration"></fq-progress-bar>
